import React from 'react';

type PropsType = React.SVGProps<SVGSVGElement>;

export function CourseArchiveIcon(props: PropsType) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.2134 1.33203H4.78671C3.36671 1.33203 2.21338 2.49203 2.21338 3.90536V13.2987C2.21338 14.4987 3.07338 15.0054 4.12671 14.4254L7.38005 12.6187C7.72671 12.4254 8.28671 12.4254 8.62671 12.6187L11.88 14.4254C12.9334 15.012 13.7934 14.5054 13.7934 13.2987V3.90536C13.7867 2.49203 12.6334 1.33203 11.2134 1.33203ZM10.0067 6.4987C9.36005 6.73203 8.68005 6.85203 8.00005 6.85203C7.32005 6.85203 6.64005 6.73203 5.99338 6.4987C5.73338 6.40536 5.60005 6.1187 5.69338 5.8587C5.79338 5.5987 6.08005 5.46536 6.34005 5.5587C7.41338 5.94536 8.59338 5.94536 9.66671 5.5587C9.92671 5.46536 10.2134 5.5987 10.3067 5.8587C10.4 6.1187 10.2667 6.40536 10.0067 6.4987Z"
        fill="currentColor"
      />
    </svg>
  );
}
